import { InvoiceLine, StructureTypeDescriptions } from '@apply/api/src/api/PaymentApi';
import { Fragment } from 'react/jsx-runtime';

interface ValuationAndUnderwritingRowParameters {
    index: number;
    invoiceLine: InvoiceLine;
}

export const ValuationAndUnderwritingRow: React.FC<ValuationAndUnderwritingRowParameters> = ({ index, invoiceLine }) => {
    return (
        <Fragment key={index}>
            <div className='invoice-type'>
                ({invoiceLine.index}) {invoiceLine.address1}
                {invoiceLine.address2?.length ? `, ${invoiceLine.address2}` : ''}{' '}
                {StructureTypeDescriptions[invoiceLine.structureType]}
            </div>
            <div className='invoice-cost'>
                ${invoiceLine.cost} + ${invoiceLine.underwritingFee} =
            </div>
            <div className='invoice-subtotal'>${Number(invoiceLine.cost) + Number(invoiceLine.underwritingFee)}</div>
            <div className='invoice-notes'>
                {invoiceLine.cost == 0 && invoiceLine.underwritingFee == 0 ? '(pay at closing)' : ''}
            </div>
        </Fragment>
    );
};
